import {LocalStore} from "./LocalStore";
// import PermissionStatic from "./StaticClass/PermissionStatic";
// import { parseObjectToQueryString } from "./stringUtils";
import ConstVar from "./staticClass/ConstVar";

export default class CheckPermission{
    static isAllowed(permissions) {
        if(!permissions) return true
        
        let permissionToCheck = [];

        if (!Array.isArray(permissions)) {
            if (typeof permissions === 'object') {
                for (let key in permissions) {
                    if (permissions.hasOwnProperty(key))
                        permissionToCheck.push(permissions[key]);
                }
            }
            else {
                permissionToCheck = [permissions];
            }
        }
        else {
            permissionToCheck = permissions;
        }
        let sessionAuthorities = LocalStore.getInstance().read(ConstVar.loginRole);
        
        if(sessionAuthorities){
            if (!Array.isArray(sessionAuthorities)) {
                sessionAuthorities = [];
            }

            for (let permission of permissionToCheck) {
                if (sessionAuthorities.indexOf(permission) >= 0) {
                    return true;
                }
            }
        }
        // parseObjectToQueryString({})
        return false;
    }
}